import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/LoginView.vue'
import Dashboard from '../views/DashboardView.vue'
// import ApiDocs from '../views/ApiDocs.vue.old'
import ForgotPassword from '../views/ForgotPasswordView.vue'
import ResetPassword from '../views/ResetPasswordView.vue'
import Files from '../views/FilesView.vue'
import * as Wiser from '../views/Wiser/index.ts'
import { useUserStore } from '@/stores/user.ts'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: 'login',
      meta: {
        title: 'Login',
        requiresAuth: false,
        showHeader: false,
      },
      path: '/login',
      component: Login,
    },
    {
      name: 'forgot-password',
      meta: {
        title: 'Wachtwoord vergeten',
        requiresAuth: false,
        showHeader: false,
      },
      path: '/forgot_password',
      component: ForgotPassword,
    },
    {
      name: 'reset-password',
      meta: {
        title: 'Reset wachtwoord',
        requiresAuth: false,
        showHeader: false,
      },
      path: '/reset_password/:token',
      props: function (route) {
        return {
          token: String(decodeURI(route.params.token as string)),
        }
      },
      component: ResetPassword,
    },
    {
      name: 'dashboard',
      meta: {
        title: 'Dashboard',
        requiresAuth: true,
        menuItem: true,
        showHeader: true,
      },
      path: '/',
      component: Wiser.Dashboard,
    },
    {
      name: 'files',
      meta: {
        title: 'Files',
        requiresAuth: true,
        requiresRole: 'ROLE_FILES',
        menuItem: true,
        showHeader: true,
      },
      path: '/files',
      component: Files,
    },
    // {
    //   name: 'api-docs',
    //   meta: {
    //     title: 'API Docs',
    //     requiresAuth: true,
    //     requiresRole: 'ROLE_API',
    //     menuItem: true,
    //     showHeader: true,
    //   },
    //   path: '/api-docs',
    //   component: ApiDocs,
    // },
    {
      name: 'wiser',
      meta: {
        title: 'Wiser',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        menuItem: true,
        showHeader: true,
      },
      path: '/wiser',
      component: Wiser.Dashboard,
    },
    {
      name: 'wiser-admin',
      meta: {
        title: 'Admin',
        requiresAuth: true,
        requiresRole: 'ROLE_SUPER_ADMIN',
        parent: 'wiser',
        menuItem: true,
        showHeader: true,
      },
      path: '/wiser/admin',
      component: Wiser.Admin,
    },
    {
      name: 'wiser-relation',
      meta: {
        title: 'Relatie',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser-relations',
        menuItem: false,
        showHeader: true,
      },
      path: '/wiser/relations/:id',
      props: function (route) {
        return {
          id: parseInt(decodeURI(route.params.id as string), 10),
        }
      },
      component: Wiser.RelationDetail,
    },
    {
      name: 'wiser-relations',
      meta: {
        title: 'Relaties',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser',
        menuItem: true,
        showHeader: true,
      },
      path: '/wiser/relations',
      component: Wiser.Relations,
    },
    {
      name: 'wiser-invoice',
      meta: {
        title: 'Factuur',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser-invoices',
        menuItem: false,
        showHeader: true,
      },
      path: '/wiser/invoices/:id',
      props: function (route) {
        return {
          id: parseInt(decodeURI(route.params.id as string), 10),
        }
      },
      component: Wiser.InvoiceDetail,
    },
    {
      name: 'wiser-invoices',
      meta: {
        title: 'Facturen',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser',
        menuItem: true,
        showHeader: true,
      },
      path: '/wiser/invoices',
      component: Wiser.Invoices,
    },
    {
      name: 'wiser-certificate',
      meta: {
        title: 'Certificaat',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser-certificates',
        menuItem: false,
        showHeader: true,
      },
      path: '/wiser/certificates/:id',
      props: function (route) {
        return {
          id: parseInt(decodeURI(route.params.id as string), 10),
        }
      },
      component: Wiser.CertificateDetail,
    },
    {
      name: 'wiser-certificates',
      meta: {
        title: 'Certificaten',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser',
        menuItem: true,
        showHeader: true,
      },
      path: '/wiser/certificates',
      component: Wiser.Certificates,
    },
    {
      name: 'wiser-offer',
      meta: {
        title: 'Offerte',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser-offers',
        menuItem: false,
        showHeader: true,
      },
      path: '/wiser/offers/:id',
      props: function (route) {
        return {
          id: parseInt(decodeURI(route.params.id as string), 10),
        }
      },
      component: Wiser.OfferDetail,
    },
    {
      name: 'wiser-offers',
      meta: {
        title: 'Offertes',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser',
        menuItem: true,
        showHeader: true,
      },
      path: '/wiser/offers',
      component: Wiser.Offers,
    },
    {
      name: 'wiser-student',
      meta: {
        title: 'Cursist',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser-students',
        menuItem: false,
        showHeader: true,
      },
      path: '/wiser/students/:id',
      props: function (route) {
        return {
          id: parseInt(decodeURI(route.params.id as string), 10),
        }
      },
      component: Wiser.StudentDetail,
    },
    {
      name: 'wiser-students',
      meta: {
        title: 'Cursisten',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser',
        menuItem: false,
        showHeader: true,
      },
      path: '/wiser/students',
      component: Wiser.Students,
    },
    {
      name: 'wiser-schedule',
      meta: {
        title: 'Planning',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser-schedules',
        menuItem: false,
        showHeader: true,
      },
      path: '/wiser/schedules/:id',
      props: function (route) {
        return {
          id: parseInt(decodeURI(route.params.id as string), 10),
        }
      },
      component: Wiser.ScheduleDetail,
    },
    {
      name: 'wiser-schedules',
      meta: {
        title: 'Planningen',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser',
        menuItem: true,
        showHeader: true,
      },
      path: '/wiser/schedules',
      component: Wiser.Schedules,
    },
    {
      name: 'wiser-address',
      meta: {
        title: 'Adres',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser-addresses',
        menuItem: false,
        showHeader: true,
      },
      path: '/wiser/addresses/:id',
      props: function (route) {
        return {
          id: parseInt(decodeURI(route.params.id as string), 10),
        }
      },
      component: Wiser.AddressDetail,
    },
    {
      name: 'wiser-addresses',
      meta: {
        title: 'Adressen',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser',
        menuItem: true,
        showHeader: true,
      },
      path: '/wiser/addresses',
      component: Wiser.Addresses,
    },
    {
      name: 'wiser-contact-person',
      meta: {
        title: 'Contactpersoon',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser-contact-persons',
        menuItem: false,
        showHeader: true,
      },
      path: '/wiser/contact-persons/:id',
      props: function (route) {
        return {
          id: parseInt(decodeURI(route.params.id as string), 10),
        }
      },
      component: Wiser.ContactPersonDetail,
    },
    {
      name: 'wiser-contact-persons',
      meta: {
        title: 'Contactpersonen',
        requiresAuth: true,
        requiresRole: 'ROLE_WISER',
        parent: 'wiser',
        menuItem: true,
        showHeader: true,
      },
      path: '/wiser/contact-persons',
      component: Wiser.ContactPersons,
    },
    { path: '/:remaining(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  const userStore = useUserStore()

  const requiresAuthentication = to.meta.requiresAuth === true

  if (requiresAuthentication || to.name === 'login') {
    const authenticated = await userStore.ensureAuthenticated()

    if (requiresAuthentication && !authenticated) {
      return {
        name: 'login',
        query: {
          redirect: to.fullPath,
        },
      }
    }

    if (to.name === 'login' && authenticated) {
      return {
        name: 'dashboard',
      }
    }
  }

  return true
})

export default router
